import React, { useState, useEffect } from "react";

export default function Topbar() {
  const [time, setTime] = useState(() => fmt(new Date()));
  useEffect(() => {
    const id = setInterval(() => setTime(fmt(new Date())), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header className="topbar">
      <div className="topbar-inner">
        <span className="topbar-id">
          <span className="dot" />
          <span className="name">bryson nyamwange</span>
        </span>
        <span className="sep">/</span>
        <span className="path">~/portfolio</span>
        <span className="sep">·</span>
        <span className="pill ok">● open to senior roles</span>
        <span className="sep">·</span>
        <span className="clock">{time}</span>
        <span className="spacer" />
        <nav>
          <a href="#about"><span className="k">01</span>about</a>
          <a href="#stack"><span className="k">02</span>stack</a>
          <a href="#history"><span className="k">03</span>experience</a>
          <a href="#credentials"><span className="k">04</span>credentials</a>
          <a href="#systems"><span className="k">05</span>projects</a>
          <a href="#contact"><span className="k">08</span>contact</a>
        </nav>
      </div>
    </header>
  );
}

function fmt(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getUTCHours())}:${p(d.getUTCMinutes())}:${p(d.getUTCSeconds())} UTC`;
}
